import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, Button, message } from "antd";
import "../styles/SubscriptionsPage.css";
import { generateTrialConfig } from "../services/api";

const { Title, Paragraph, Link } = Typography;

const SubscriptionsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: initialUser } = location.state || {};

  // Если зашли напрямую по URL и данных нет — редирект на главную
  useEffect(() => {
    if (!initialUser) {
      navigate("/");
    }
  }, [initialUser, navigate]);

  const [loading, setLoading] = useState(false);

  // Проверяем, есть ли у пользователя право на пробный период
  const handleTrial = async () => {
    if (!initialUser?.is_can_trial) {
      message.info("Вы уже использовали пробный период!");
      return;
    }

    setLoading(true);
    try {
      // Вызываем АПИ для генерации пробной конфигурации
      const response = await generateTrialConfig(initialUser.telegram_id);

      if (response.success) {
        message.success("Пробный период успешно активирован!");
        navigate("/config-success", {
          state: { user: response.user, config: response.config },
        });
      }
    } catch (error) {
      message.error(error?.toString() || "Ошибка при оформлении пробного периода");
    } finally {
      setLoading(false);
    }
  };

  // Если initialUser нет — ничего не рендерим (редирект уже ушёл выше)
  if (!initialUser) return null;

  return (
    <div className="subscriptions-page-container">
      <Title className="greeting">
        Попробуйте VPN на 5 дней бесплатно и без ограничений!
      </Title>

      <div className="gray-container-sub">
        <div className="white-container-sub">
        <Paragraph className="sub-details">
  Получите бесплатный доступ к 
  <Link href="https://t.me/vpn_neo_bot" target="_blank"> VPNNEO </Link> 
  на 5 дней без ограничений скорости и трафика! После пробного периода вы сможете продлить подписку в нашем боте.  
  <Link href="https://t.me/vpn_neo_bot" target="_blank"> VPNNEO</Link> — свобода и безопасность в сети!
</Paragraph>
        </div>

        <Button
          type="primary"
          className="subscribe-button"
          onClick={handleTrial}
          loading={loading}
        >
          {loading ? "Активируем..." : "Получить"}
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionsPage;
